var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.classes,on:{"mouseover":function($event){$event.stopPropagation();_vm.isHover = true},"mouseleave":function($event){_vm.isHover = false},"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }